import styles from "./RadioGroup.module.scss";

interface RadioGroupOption {
  label?: React.ReactNode;
  value?: string | number;
  disabled?: boolean;
}

interface RadioGroupProps {
  name?: string;
  value?: string | number;
  options: RadioGroupOption[];
  onChange?: (value?: string | number) => void;
}

const RadioGroup: React.FC<RadioGroupProps> = ({
  name,
  value,
  options,
  onChange,
}) => {
  return (
    <div role="radiogroup">
      {options.map((option) => (
        <label key={option.value} className={styles.radio}>
          <input
            type="radio"
            className={styles.input}
            name={name}
            value={option.value}
            disabled={option.disabled}
            checked={value === option.value}
            onChange={() => onChange?.(option.value)}
          />
          <span className={styles.label}>{option.label}</span>
        </label>
      ))}
    </div>
  );
};

export default RadioGroup;
